import { createFileRoute } from '@tanstack/react-router'
import ConceptShortInformation from 'Concept/components/Concept/Sections/ConceptShortInformation'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/concept/$conceptId/baseInfo')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <ConceptShortInformation />
        </Guard>
    ),
})
